import styled from 'styled-components'
import RoomChargeIcon from '../../../../img/svg/roomCharge'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const ResultBlock = styled.div`
	padding: 0.5em 0;
	text-align: center;
`
ResultBlock.displayName = 'ResultBlock'

export const ResultBadge = styled.span`
	display: grid;
	place-items: center;
	margin: 0 auto;
	width: 4em;
	height: 4em;
	border-radius: 50%;
	background: ${colorTheme.roomCharge.modal.outcome.pending.background};
	color: ${colorTheme.roomCharge.modal.outcome.pending.icon};

	&.failed {
		background: ${colorTheme.roomCharge.modal.outcome.failed.background};
		color: ${colorTheme.roomCharge.modal.outcome.failed.icon};
	}
`
ResultBadge.displayName = 'ResultBadge'

export const ResultBadgeIcon = styled(RoomChargeIcon)`
	width: 2.25em;
	height: 2.25em;
`
ResultBadgeIcon.displayName = 'ResultBadgeIcon'

export const ResultTitle = styled.p`
	margin-top: 1em;
	font-size: 1.12em;
	font-weight: 600;
	color: ${colorTheme.roomCharge.modal.title};
`
ResultTitle.displayName = 'ResultTitle'

export const ResultText = styled.p`
	margin-top: 0.31em;
	font-size: 1em;
	color: ${colorTheme.roomCharge.modal.subtitle};
`
ResultText.displayName = 'ResultText'
